import { ApiError } from './api-error';

export class FormSubmittedError extends ApiError {}
